// Dependencies
import { useState, useRef, useCallback } from "react";

import { useScroll  } from 'react-use';
import { useResizeDetector } from 'react-resize-detector';
import ScrollContainer from 'react-indiana-drag-scroll'

import _ from 'lodash'; 
import _cx from 'classnames'; 

// Types
import { Types, Components } from '../utils/types';

// Utils
import {  } from '../utils/config' 
import { getOptionIcon, getNavButtonIcon } from '../utils/helpers' 

const OptionSelect = ({hasIcons, options}: Components.OptionSelect) => {

    const [isScrollable, setIsScrollable] = useState<boolean>(false);
    
    const containerRef = useRef<any>(null);
    const {x: containerScrollX} = useScroll(containerRef);

    // TODO:    Scroll to next element / by average scroll width
    const scrollTo = (direction: 'left' | 'right', value: number = 250) => {
    
        containerRef?.current?.scrollBy({
            left: value * (direction === 'left' ? -1 : 1),
            behavior: 'smooth'
        });

    }

    const onResize = useCallback(() => {
        setIsScrollable( ( containerRef?.current.scrollWidth ) > containerRef?.current.offsetWidth );
    }, []);

    useResizeDetector({
        targetRef: containerRef,
        handleHeight: false,
        refreshMode: 'throttle',
        refreshRate: 250,
        onResize
    });

    return (<>
        {isScrollable && 
            <SwatchesNavButton 
                direction="prev"
                isVisible={ (containerScrollX - 32 )> 0 }
                onClick={() => scrollTo('left')} />
        } 

        <div className={
            _cx("options__wrapper", {
                'fade-from-left': containerScrollX > 0,
                'fade-from-right': containerScrollX < (containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth),
            })
        }> 
            <ScrollContainer nativeMobileScroll={true} vertical={false} horizontal={true} className="options__container" innerRef={containerRef}>
                { options.map( (option: Types.FormOption, index: number) => <OptionField key={index} icon={ getOptionIcon(option) } {...option} /> ) }
            </ScrollContainer>
        </div>

        {isScrollable && 
            <SwatchesNavButton
                direction="next"
                isVisible={ (containerScrollX + 32 ) < (containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth) } 
                onClick={() => scrollTo('right')} /> 
        }
    </>) 
 
}

const SwatchesNavButton = ({direction, isVisible, onClick}: any) => {
 
    return (
        <div className={`nav__button ${direction}${isVisible ? ' is-visible' : ''}`} onClick={onClick}>
            { getNavButtonIcon() }
        </div> 
    )

}

const OptionField = ({ icon, label, color, value }: Components.OptionField) => {

    const [isHovering, setIsHovering] = useState<boolean>(false);

    return (<>
       <a 
            href={`/${value}`}
            className={_cx('form-field', 'radio', {
                'has-icon': !_.isEmpty(icon),
            })} 
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            style={isHovering ? {backgroundColor: color} : undefined} 
        >
            <div 
                className="form-field__icon"
                style={ ! isHovering ? {backgroundColor: color} : undefined}     
            >
                <img src={icon} alt={`${value}-icon`} />
            </div>
            <div className="form-field__label">{label}</div>
        </a>
    </>)

}

export default OptionSelect;